import React, {useEffect, useRef} from 'react';
import {GET_COL_AGGREGATE_DATA} from '../../../api';
import $ from "jquery";
import DataTable from "datatables.net-dt";
import cogoToast from "cogo-toast";

let searchableFields = [
    { field: 'name', isNumeric: false },
    { field: 'email', isNumeric: true }
]

const Team = () => {

    document.title = "Team";

    const token = localStorage.getItem('jwtToken');

    const searchQueryRef = useRef('');
    const searchTimeout = useRef(null);

    const handleSearch = (e) => {
        const value = e.target.value;
        clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(() => {
            searchQueryRef.current = value;
            reloadTable();
        }, 800);
    };

    useEffect(() => {
        let table = new DataTable('#admin',{
            responsive: true,
            dom: 'tip',
            language: {
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Client Data</p>'
            },
            searching: false,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: (data, callback) => {
                $.ajax(GET_COL_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    contentType: 'application/json',
                    data: JSON.stringify({
                        query: searchQueryRef.current,
                        collection: "admins",
                        filter: [
                            {
                                $match: {
                                    role: "team",
                                    ...(searchQueryRef.current ? {
                                        $or: searchableFields.map(({ field, isNumeric }) => ({
                                            [field]: isNumeric
                                                ? Number(searchQueryRef.current)
                                                : { $regex: searchQueryRef.current, $options: "i" }
                                        }))
                                    } : {})
                                },
                            },
                            {
                                $lookup: {
                                    from: "users",
                                    let: { adminId: "$_id" },
                                    pipeline: [
                                        { $match: { $expr: { $eq: ["$admin", "$$adminId"] } } },
                                        { $count: "count" }
                                    ],
                                    as: "users"
                                }
                            },
                            {
                                $lookup: {
                                    from: "assignments",
                                    let: { adminId: "$_id" },
                                    pipeline: [
                                        { $match: { $expr: { $eq: ["$admin", "$$adminId"] } } },
                                        { $count: "count" }
                                    ],
                                    as: "assignments"
                                }
                            },
                            {
                                $addFields: {
                                    users_count: {
                                        $ifNull: [{ $arrayElemAt: ["$users.count", 0] }, 0]
                                    },
                                    assignments_count: {
                                        $ifNull: [{ $arrayElemAt: ["$assignments.count", 0] }, 0]
                                    }
                                }
                            },
                            {
                                $sort: { assignments_count: -1 }
                            },
                            {
                                $project: {
                                    _id: 1,
                                    name: 1,
                                    email: 1,
                                    role: 1,
                                    permission: 1,
                                    users_count: 1,
                                    assignments_count: 1
                                }
                            },
                            {
                                $facet: {
                                    results: [
                                        { $skip: data.start },
                                        { $limit: data.length }
                                    ],
                                    totalCount: [
                                        { $count: "total" }
                                    ]
                                }
                            }
                        ]
                    }),
                    success : function(res) {
                        let array = [];
                        res.data[0].results.map((data) => {
                            array.push({raw: data})
                        });

                        $("#total-count").text(res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0);

                        callback({
                            recordsTotal: res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0,
                            recordsFiltered: res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                { "className": "align-middle", "targets": "_all" },
                {
                    "render": function (data) {
                        return `<div class="d-flex align-items-center">
                            <img style="margin-right: 12px" src="assets/img/profile.png" height="48" alt="profile"/>
                            <span class="text-default">${data.name}</span>
                        </div>`;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.assignments_count;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return data.users_count;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only"><a href="#/team/${data._id}" class="btn btn-outline-success">View Profile</a></nav>`
                    },
                    "targets": 3
                }
            ]
        });

        return () => {
            table.destroy();
        }
    }, []);

    const reloadTable = () => {
        new DataTable('#admin').ajax.reload(null, false);
    };

    return (
        <div className="content-body">
            <div className="d-flex justify-content-between">
                <div>
                    <h2>My Team</h2>
                    <h5>Monitoring your global digital presence across all platforms.</h5>
                </div>
            </div>

            <div className="card card-view mt-3">
                <div className="p-3 d-flex justify-content-between align-items-end">
                    <div>
                        <h2 style={{fontSize: 64}} id="total-count">0</h2>
                        <h5 style={{marginBottom: 0}}>Total teams</h5>
                    </div>

                    <div className="position-relative" style={{ width: "20%" }}>
                        <svg style={{position: "absolute", left: "12px", top: "54%", transform: "translateY(-50%)", pointerEvents: "none"}} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.7832 14.3911L20 18.6069L18.6069 20L14.3911 15.7832C12.8224 17.0407 10.8713 17.7246 8.86088 17.7218C3.96968 17.7218 0 13.7521 0 8.86088C0 3.96968 3.96968 0 8.86088 0C13.7521 0 17.7218 3.96968 17.7218 8.86088C17.7246 10.8713 17.0407 12.8224 15.7832 14.3911ZM13.8082 13.6605C15.0574 12.3754 15.7552 10.6531 15.7527 8.86088C15.7527 5.05366 12.6681 1.96909 8.86088 1.96909C5.05366 1.96909 1.96909 5.05366 1.96909 8.86088C1.96909 12.6681 5.05366 15.7527 8.86088 15.7527C10.6531 15.7552 12.3754 15.0574 13.6605 13.8082L13.8082 13.6605Z" fill="#9893AE"/>
                        </svg>
                        <input type="text" className="form-control" placeholder="Search team..." style={{ paddingLeft: "40px" }} onChange={handleSearch}/>
                    </div>
                </div>

                <div className="card-body table-responsive p-0">
                    <table id="admin" className="table">
                        <thead>
                        <tr>
                            <th className="wd-25p">Team Leader</th>
                            <th className="wd-25p">Assignments</th>
                            <th className="wd-25p">Influencers</th>
                            <th className="wd-25p">Action</th>
                        </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </div>
    )
};

export default Team;
